export default __webpack_public_path__ + "3ee01b42944586cc64dfc5e333238328.png";